import { Module } from 'wrapper6'
import PostService from '../services/_post-service'

export default class PostsPager extends Module {
  /*
     * Initialize Module
     */
  ready () {
    this.button = document.getElementById('loadmore-posts')
    this.postsList = document.getElementById('posts-list')
    this.progressCount = document.getElementById('progress_count')
    this.progressIndicator = document.getElementById('progress-indicator')

    this.page = 1

    if (!this.button) return

    this.button.addEventListener('click', () => {
      if (!this.button.classList.contains('disabled')) {
        this.getPosts()
      }
    })
  }

  /*
     * Get Posts from the posts service
     */
  async getPosts () {
    const posts = await PostService.getPosts({
      action: 'page_posts',
      paged: 2
    })

    this.page++
    this.page_total = posts.pages

    this.postsList.insertAdjacentHTML('beforeend', posts.html)
    this.setPagination(posts.pages, posts.count)
  }

  /*
     * Update the pagination
     */
  setPagination (pages, count) {
    if (pages === this.page) {
      this.button.innerHTML = 'Alle indlæg indlæst'
      this.button.classList.add('disabled')
      this.button.classList.add('white')
    } else {
      this.button.innerHTML = 'Indlæs flere'
      this.button.classList.remove('disabled')
      this.button.classList.remove('white')
    }

    const shown = this.postsList.getElementsByClassName('post').length

    this.progressCount.innerHTML = 'Du har nu set ' + shown + ' af ' + count + ' produkter'
    this.progressIndicator.style.width = (100 / count) * shown + '%'
  }
}
